var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "commitments" }, [
    _c(
      "a",
      {
        staticClass: "container-fluid",
        attrs: { href: _vm.commitments.url, target: "_blank" },
      },
      [
        _c(
          "div",
          { staticClass: "row pt-2 bg-white" },
          [
            _c("header-signature", {
              staticClass: "col-12 py-0",
              attrs: { text: _vm.commitments.title },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row bg-white" }, [
          _c("div", { staticClass: "col-12 col-md-3" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-1 mb-md-2" },
              [
                _c("span", {
                  staticClass:
                    "icon h1 mb-0 pb-0 icon-Fast-delivery text-primary3",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-1 fw-bold" }, [
                  _vm._v(_vm._s(_vm.commitments.line1)),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-3 ps-lg-2" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-1 mb-md-2" },
              [
                _c("span", {
                  staticClass: "icon h1 mb-0 pb-0 icon-finance text-primary3",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-1 fw-bold" }, [
                  _vm._v(_vm._s(_vm.commitments.line2)),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-3 ps-lg-2" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-1 mb-md-2" },
              [
                _c("span", {
                  staticClass:
                    "icon h1 mb-0 pb-0 icon-Orange-Trust-Badge text-primary3",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-1 fw-bold" }, [
                  _vm._v(_vm._s(_vm.commitments.line4)),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-3 ps-lg-2" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-1 mb-md-2" },
              [
                _c("span", {
                  staticClass:
                    "icon h1 mb-0 pb-0 icon-shop-subscriptions text-primary3",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-1 fw-bold" }, [
                  _vm._v(_vm._s(_vm.commitments.line5)),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }